import React from "react";
import { Helmet } from "react-helmet-async";
import { s3BucketURL } from "@/helpers/environment";

const DEFAULT_TITLE = "dripit";
const DEFAULT_DESCRIPTION = `dripit - Discover new music trends and predict the Hype`;
const DEFAULT_IMAGE = `${s3BucketURL}dripit_bet_on_hype.jpg`;

export interface DefaultMetaTagsProps {
  title?: string;
  ogTitle?: string;
  description?: string;
  image?: string;
}

export const DefaultMetaTags: React.FC<DefaultMetaTagsProps> = ({
  title = DEFAULT_TITLE,
  ogTitle,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="og:url" content={window.location.href.split("?")[0]} />
    <meta property="og:title" content={ogTitle ?? title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={image} />
    <meta property="og:type" content="website" />
  </Helmet>
);
